import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Button, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faEnvelope, 
  faPhoneAlt,
  faBars,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import { 
  faFacebookF, 
  faTwitter, 
  faYoutube 
} from '@fortawesome/free-brands-svg-icons';
import logo from '../assets/img/logo.png';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`sticky-top ${isScrolled ? 'header-scrolled' : ''}`}>
      {/* Top Bar */}
      <div className="top-bar bg-dark py-2 d-none d-lg-block">
        <Container>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              {/* Oficina Guadalajara */}
              <div className="topbar-item pe-4">
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faEnvelope} className="text-primary me-2" />
                  <div className="d-flex flex-column">
                    <span className="text-white-50 small">GDL</span>
                    <a href="mailto:contacto@heza.com.mx" className="text-white small">contacto@heza.com.mx</a>
                  </div>
                </div>
              </div>
              <div className="topbar-item pe-4">
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faPhoneAlt} className="text-primary me-2" />
                  <div className="d-flex flex-column">
                    <span className="text-white-50 small">GDL</span>
                    <a href="tel:3331674762" className="text-white small">(33) 3167-4762</a>
                  </div>
                </div>
              </div>
              
              {/* Separador visual */}
              <div className="topbar-item pe-4">
                <div className="text-white-50">|</div>
              </div>
              
              {/* Oficina Puerto Vallarta */}
              <div className="topbar-item">
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faPhoneAlt} className="text-primary me-2" />
                  <div className="d-flex flex-column">
                    <span className="text-white-50 small">PV</span>
                    <a href="tel:3223651449" className="text-white small">(322) 365-1449</a>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="d-flex social-links">
              <a href="https://www.facebook.com/hezaconsultoriaintegral" target="_blank" rel="noopener noreferrer" className="social-link">
                <FontAwesomeIcon icon={faFacebookF} className="hover-effect" />
              </a>
              <a href="https://x.com/HEZAConsultoria" target="_blank" rel="noopener noreferrer" className="social-link">
                <FontAwesomeIcon icon={faTwitter} className="hover-effect" />
              </a>
              <a href="https://www.youtube.com/channel/UCwFvryoTPGgpO-1CPCIgcqA" target="_blank" rel="noopener noreferrer" className="social-link">
                <FontAwesomeIcon icon={faYoutube} className="hover-effect" />
              </a>
            </div>
          </div>
        </Container>
      </div>

      {/* Main Navigation */}
      <Navbar expand="lg" expanded={expanded} onToggle={setExpanded} className="main-nav bg-white">
        <Container fluid className="px-lg-4">
          <Navbar.Brand as={Link} to="/" className="logo-container">
            <img 
              src={logo} 
              alt="HEZA Consultoría" 
              className="main-logo" 
            />
          </Navbar.Brand>

          <Navbar.Toggle 
            aria-controls="main-nav" 
            className="custom-toggler"
            onClick={() => setExpanded(!expanded)}
          >
            <FontAwesomeIcon icon={expanded ? faTimes : faBars} />
          </Navbar.Toggle>

          <Navbar.Collapse id="main-nav" className="justify-content-between">
            <Nav className="mx-auto">
              {[
                { to: '/', text: 'Inicio' },
                { to: '/nosotros', text: 'Nosotros' },
                { to: '/servicios', text: 'Servicios' },
                { to: '/contacto', text: 'Contacto' },
                { to: '/noticias', text: 'Noticias' },
                { to: '/eventos', text: 'Eventos' }
              ].map((link, i) => (
                <Nav.Link 
                  key={i} 
                  as={Link} 
                  to={link.to} 
                  className="nav-link"
                  onClick={() => setExpanded(false)}
                >
                  {link.text}
                </Nav.Link>
              ))}
            </Nav>

            <div className="nav-buttons d-flex">
              <Button 
                as={Link} 
                to="/servicios/diagnostico-empresarial" 
                variant="primary" 
                className="me-3 action-btn"
                onClick={() => setExpanded(false)}
              >
                Diagnóstico
              </Button>
              <Button 
                as={Link} 
                to="/devoluciones" 
                variant="outline-primary" 
                className="action-btn"
                onClick={() => setExpanded(false)}
              >
                Devoluciones
              </Button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};
                
export default Header;

// Estilos CSS personalizados para el header con información de contacto dual
const headerStyles = `
  .topbar-item {
    transition: all 0.3s ease;
  }
  
  .topbar-item:hover {
    transform: translateY(-1px);
  }
  
  .topbar-item .d-flex.flex-column {
    line-height: 1.2;
  }
  
  .topbar-item .text-white-50.small {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
  
  .topbar-item a {
    text-decoration: none;
    transition: color 0.3s ease;
  }
  
  .topbar-item a:hover {
    color: var(--primary) !important;
  }
  
  /* Responsive styles */
  @media (max-width: 1200px) {
    .topbar-item {
      padding-right: 1rem !important;
    }
    
    .topbar-item .text-white-50.small {
      font-size: 0.65rem;
    }
    
    .topbar-item a.small {
      font-size: 0.8rem;
    }
  }
  
  @media (max-width: 992px) {
    .topbar-item {
      padding-right: 0.5rem !important;
    }
    
    .topbar-item .d-flex.flex-column {
      min-width: 80px;
    }
  }
  
  @media (max-width: 768px) {
    .top-bar {
      display: none !important;
    }
  }
`;

// Agregar estilos al head del documento
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = headerStyles;
  document.head.appendChild(styleElement);
}